module.exports = __webpack_public_path__ + "img/kh_ewm@2x.64985652.png";